import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getLoggedInUserPermissionNames } from '../selectors/userSelectors';
import LibraryFormPanel from '../components/LibraryFormPanel';
import { getCurrentOrg } from '../selectors/organizationSelectors';
import { deleteFormTemplate, updateFormTemplates, cloneRhinoform, fetchFormTemplates, getFormTemplateById } from '../reducers/formReducer';

class LibraryFormPanelContainer extends Component {
  state = {
    showDeleteFormModal: false,
    isPdfViewerOpen: false,

  }

  handleToggleModal = () => {
    this.setState({ showDeleteFormModal: !this.state.showDeleteFormModal });
  }

  handleDeleteForm = (formId) => {
    this.props.deleteFormTemplate(formId, this.props.selectedFormFilter)
      .then(() => {
        this.handleToggleModal();
        this.props.history.replace('/settings/organization/library/forms');
        this.props.filterUpdateHandler(this.props.selectedFormFilter);
      });
  }

  handlePublishForm = (formId) => {
    const payload = {
      isPublished: true,
    };
    this.props.updateFormTemplates(formId, payload, this.props.selectedFormFilter).then(() => {
      this.props.filterUpdateHandler(this.props.selectedFormFilter);
    });
  }

  handleFormConfiguration = () => {
    this.props.history.replace(`/settings/organization/library/forms/edit/${this.props.activeFormTemplate.formId}`);
  }

  togglePdfViewer = async () => {
    const opening = !this.state.isPdfViewerOpen;
    // The saved-content download route (savedContentPDF) audits by contactId, and for a form
    // TEMPLATE that id is the form's createdBy (there is no patient). The templates LIST we
    // already have doesn't include createdBy — only getFormTemplateById returns it — so fetch the full
    // form on open, awaited, so createdBy is in state before the PDF URL is built (otherwise
    // the first request goes out without ?contactId= and 504s).
    // NOTE: the better fix lives in rhinoform — include createdBy in the form-templates list
    // response, which would remove this extra per-open fetch entirely.
    if (opening && this.props.activeFormTemplate?.formId) {
      await this.props.getFormTemplateById(this.props.activeFormTemplate.formId);
    }
    this.setState({ isPdfViewerOpen: opening });
  }

  handleCloneForm = (formId) => {
    const payload = {
      formId,
      edit: true,
    };
    this.props.cloneRhinoform(payload).then(() => {
      this.props.fetchFormTemplates(this.props.selectedFormFilter);
    });
  }

  render() {
    const props = {
      handleTogglePanel: this.props.handleTogglePanel,
      activeFormTemplate: this.props.activeFormTemplate,
      showDeleteFormModal: this.state.showDeleteFormModal,
      isFormTemplateDeleting: this.props.isFormTemplateDeleting,
      loggedInUserPermissions: this.props.loggedInUserPermissions,
      handleToggleModal: this.handleToggleModal,
      handleDeleteForm: this.handleDeleteForm,
      handlePublishForm: this.handlePublishForm,
      isFormTemplateUpdating: this.props.isFormTemplateUpdating,
      handleFormConfiguration: this.handleFormConfiguration,
      togglePdfViewer: this.togglePdfViewer,
      isPdfViewerOpen: this.state.isPdfViewerOpen,
      handleCloneForm: this.handleCloneForm,
      currentOrganization: this.props.currentOrganization,
      offices: this.props.offices,
      formS3Url: this.props.formS3Url,
    };
    return (
      <LibraryFormPanel {...props} />
    );
  }
}

LibraryFormPanelContainer.propTypes = {
  handleTogglePanel: PropTypes.func.isRequired,
  activeFormTemplate: PropTypes.object.isRequired,
  selectedFormFilter: PropTypes.string.isRequired,
  filterUpdateHandler: PropTypes.func.isRequired,
  deleteFormTemplate: PropTypes.func.isRequired,
  isFormTemplateDeleting: PropTypes.bool.isRequired,
  isFormTemplateUpdating: PropTypes.bool.isRequired,
  loggedInUserPermissions: PropTypes.array.isRequired,
  updateFormTemplates: PropTypes.func.isRequired,
  cloneRhinoform: PropTypes.func.isRequired,
  fetchFormTemplates: PropTypes.func.isRequired,
  getFormTemplateById: PropTypes.func.isRequired,
  currentOrganization: PropTypes.object.isRequired,
  offices: PropTypes.object.isRequired,
  formS3Url: PropTypes.object,
};

const mapStateToProps = (state) => {
  const { form, office } = state;
  return {
    isFormTemplateDeleting: form.isFormTemplateDeleting,
    isFormTemplateUpdating: form.isFormTemplateUpdating,
    loggedInUserPermissions: getLoggedInUserPermissionNames(state),
    formId: form.form.formId,
    formS3Url: form.formS3Url,
    currentOrganization: getCurrentOrg(state),
    offices: office.offices,
  };
};

const actions = {
  deleteFormTemplate,
  updateFormTemplates,
  cloneRhinoform,
  fetchFormTemplates,
  getFormTemplateById,
};

export default connect(mapStateToProps, actions)(withRouter(LibraryFormPanelContainer));
